import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import Icon from '../Icon/Icon.js';
import { noop } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { DROPDOWN_VARIANT } from './constants.js';
import { DropdownSelectWrapper, ToggleIconWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "label", "outline", "disabled", "selected", "ariaLabel", "ariaLabelledBy", "ariaRequired", "ariaDescribedBy", "handleItemClick", "dropdownItems", "variant", "customStyle"];
var DropdownSelect = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    outline = _ref.outline,
    disabled = _ref.disabled,
    selected = _ref.selected,
    ariaLabel = _ref.ariaLabel,
    ariaLabelledBy = _ref.ariaLabelledBy,
    ariaRequired = _ref.ariaRequired,
    ariaDescribedBy = _ref.ariaDescribedBy,
    handleItemClick = _ref.handleItemClick,
    dropdownItems = _ref.dropdownItems,
    variant = _ref.variant,
    customStyle = _ref.customStyle,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var _safeCustomStyle = safeCustomStyle(customStyle),
    dropdownInputStyle = _safeCustomStyle.dropdownInputStyle;
  var value = dropdownItems[selected] ? dropdownItems[selected].value : '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownSelectWrapper, _extends({
    id: "".concat(id, "-toggle"),
    value: value,
    variant: variant,
    outline: outline,
    disabled: disabled,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy || (label ? "".concat(id, "-label") : undefined),
    "aria-required": ariaRequired,
    "aria-describedby": ariaDescribedBy,
    onChange: handleItemClick,
    dropdownInputStyle: dropdownInputStyle,
    theme: theme,
    ref: ref,
    "data-testid": "dropdown-native-test",
    "data-value": value
  }, rest), dropdownItems.map(function (elem) {
    return /*#__PURE__*/React.createElement("option", {
      id: "".concat(id, "-item-").concat(elem.value),
      key: "item-".concat(elem.value),
      value: elem.value,
      disabled: elem.disabled,
      "data-selected": value === elem.value
    }, elem.label);
  })), /*#__PURE__*/React.createElement(ToggleIconWrapper, {
    "aria-hidden": true
  }, /*#__PURE__*/React.createElement(Icon, {
    manulifeName: "chevrondown",
    fill: "".concat(disabled ? theme.colorPalette.neutralColors.dark.shade_light_4 : theme.colorPalette.neutralColors.dark.shade_light_1),
    width: "12px",
    "data-testid": "dropdown-native-icon"
  })));
});
process.env.NODE_ENV !== "production" ? DropdownSelect.propTypes = {
  /** ID of DOM element for dropdown */
  id: PropTypes.string.isRequired,
  /** label component for input */
  label: PropTypes.node,
  /** flag to show/hide error outline */
  outline: PropTypes.bool,
  /** flag to disable dropdown */
  disabled: PropTypes.bool,
  /** index of selected item, default is 0 */
  selected: PropTypes.number,
  /** override input aria-label */
  ariaLabel: PropTypes.string,
  /** override input aria-labelledby */
  ariaLabelledBy: PropTypes.string,
  /** global attribute aria-required */
  ariaRequired: PropTypes.bool,
  /** aria-describedby attribute */
  ariaDescribedBy: PropTypes.string,
  /** function to call onClick of a dropdown item */
  handleItemClick: PropTypes.func,
  /** Dropdown menu items */
  dropdownItems: PropTypes.arrayOf(PropTypes.shape({
    /** value for the item, equivalent to option value in select element */
    value: PropTypes.string.isRequired,
    /** label for the item, equivalent to option label in select element */
    label: PropTypes.string.isRequired,
    /** Item is not selectable if it is disabled */
    disabled: PropTypes.bool
  })),
  /** Which style of input to use */
  variant: PropTypes.oneOf([DROPDOWN_VARIANT.BASIC, DROPDOWN_VARIANT.BASIC_LINE, DROPDOWN_VARIANT.BASIC_LINE_DASHED]),
  /** custom styles */
  customStyle: PropTypes.shape({
    dropdownMenuStyle: PropTypes.object // styling for Dropdown Input items
  })
} : void 0;
DropdownSelect.defaultProps = {
  label: null,
  outline: false,
  disabled: false,
  selected: 0,
  ariaLabel: undefined,
  ariaLabelledBy: undefined,
  ariaRequired: false,
  ariaDescribedBy: undefined,
  handleItemClick: noop,
  dropdownItems: [],
  variant: DROPDOWN_VARIANT.BASIC,
  customStyle: {
    dropdownMenuStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? DropdownSelect.displayName = 'DropdownSelect' : void 0;
var DropdownSelect$1 = DropdownSelect;

export { DropdownSelect$1 as default };
